import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ColorName } from '@common/services';

import { BtnActionComponent } from '../btn-action/btn-action.component';

@Component({
    selector: 'aa-btn-action-icon',
    templateUrl: './btn-action-icon.component.html',
    styleUrls: [
        '../btn-action/btn-action.component.scss',
        './btn-action-icon.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BtnActionIconComponent extends BtnActionComponent
{
    @Input() btnAspect: ColorName.Success | ColorName.Danger = ColorName.Success;
    @Input() icon: string;

    constructor ()
    {
        super();
    }
}
